//100
// function validarMonto(long) {
//   if (/^[a-zA-Z\s\,\.\''\-]{1,150}$/i.test(long)) {
//     return "aceptadoMonto";
//   } else {
//     return "errorMonto";
//   }
// }
// ^[0-9]\d{0,7}
// export default validarMonto;

function validarMonto(long) {
  // if (/^([0-9])([^--]){0,9}$/g.test(long) || long === "") {
  //   return "aceptadoDominio";
  // } else {
  //   return "errorDominio";
  // } 

  if (/^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$/g.test(long) || long === "" || long === "0") {
    return "aceptadoDominio";
  } else {
    return "errorDominio";
  }
}

export default validarMonto;

// function validarMonto(e) {
//   var key = e.keyCode || e.which,
//     tecla = String.fromCharCode(key).toLowerCase(),
//     letras = " áéíóúabcdefghijklmnñopqrstuvwxyz",
//     especiales = [8, 37, 39, 46],
//     tecla_especial = false;

//   for (var i in especiales) {
//     if (key == especiales[i]) {
//       tecla_especial = true;
//       break;
//     }
//   }

//   if (letras.indexOf(tecla) == -1 && !tecla_especial) {
//     return false;
//   }
// }   /^\d{0,8}$/g.test(long) || long === ""

// export default validarMonto;
